import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { combineLatest } from 'rxjs';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ListasService } from '../../../services/listas.service';
import { EmpresaService } from '../../auth/services/empresa.service';
import { FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { ListaValorResponseDto } from '../../../dto/tramites/lista_valor.dto';
import { Constants_solicitudes } from '../../administracion-funcional/constants/constants-solicitudes';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { Constants_empresa } from "../constants/constants_empresa";
import { DatosAdicionalesDTO } from "../../../dto/empresa/empresa.dto";

@Component({
  selector: 'app-modal-datos-observatorio',
  templateUrl: './modal-datos-observatorio.component.html',
  styleUrl: './modal-datos-observatorio.component.scss'
})
export class ModalDatosObservatorioComponent implements OnInit {
  @ViewChild('modalDatosObservatorio') modalDatosObservatorio!: ElementRef;

  // Multilenguaje
  modalText: any = {};
  comunText: any = {};
  gestionText: any = {};
  allFields: FormField[] = [];
  userInfoSession: UserDataDto = {};

  constructor(
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly listasService: ListasService,
    private readonly empresaService: EmpresaService
  ) {
    this.userInfoSession = JSON.parse(sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) || '{}');
  }

  ngOnInit(): void {
    combineLatest({
      modal: this.translate.stream('crear-empresa'),
      comun: this.translate.stream('comun-label'),
      gestion: this.translate.stream('gestion solicitudes-pj')
    }).subscribe(({ modal, comun, gestion }) => {
      // Asignar traducciones a variables
      this.modalText = modal;
      this.comunText = comun;
      this.gestionText = gestion;
      this.cargarFormulario();
    });
    this.getListas();
    this.datosAdicionalesRegistrados();
  }

  cargarFormulario() {
    this.allFields = [
      {
        name: 'idTamanoEmpresa',
        label: this.modalText['tamanoEmpresa'],
        type: 'select',
        required: true,
        width: '6',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.modalText['tecnologias-required']
        },
      },
      {
        name: 'numeroEmpleados',
        label: this.modalText['empleados'],
        type: 'number',
        required: true,
        width: '6',
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_TELEFONO),
          Validators.min(1)
        ],
        errorMessages: {
          required: this.gestionText['empleados-required'],
          pattern: this.comunText['numero_pattern'],
          min: this.comunText['numero_minimo']
        },
      },
      {
        name: 'ciiuPrincipal',
        label: this.modalText['ciiu'],
        type: 'select',
        required: true,
        width: '6',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.modalText['tecnologias-required']
        },
      },
      {
        name: 'antiguedad',
        label: this.modalText['antiguedad'],
        type: 'number',
        required: true,
        width: '6',
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_TELEFONO),
          Validators.min(1)
        ],
        errorMessages: {
          required: this.comunText['antiguedad-required'],
          pattern: this.comunText['numero_pattern'],
          min: this.comunText['numero_minimo']
        },
      },
      {
        name: 'idFormaJuridica',
        label: this.modalText['formaJuridica'],
        type: 'select',
        required: true,
        width: '6',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.modalText['tecnologias-required']
        },
      },
      {
        name: 'tecnologias',
        label: this.modalText['tecnologias'],
        type: 'select',
        required: true,
        width: '6',
        validation: [
          Validators.required
        ],
        errorMessages: {
          required: this.modalText['tecnologias-required']
        },
      }
    ];
  }

  getListas() {
    this.listasService
      .listaValor(Constants.CODIGO_CIIU)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.allFields = this.allFields.map(field => {
          if (field.name === 'ciiuPrincipal') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Otro_valor!,
              Nombre: `${item.Otro_valor!} - ${item.Valor!}`,
            }));
          }
          return field;
        });
      });
    this.listasService
      .listaValor(Constants_solicitudes.LISTA_TAMANIOS)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.allFields = this.allFields.map(field => {
          if (field.name === 'idTamanoEmpresa') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });

    this.listasService
      .listaValor(Constants.TIPO_SOCIEDAD)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.allFields = this.allFields.map(field => {
          if (field.name === 'idFormaJuridica') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });
    this.listasService
      .listaValor(Constants_empresa.TECNOLOGIAS)
      .subscribe(response => {
        const data = response as ListaValorResponseDto[];
        this.allFields = this.allFields.map(field => {
          if (field.name === 'tecnologias') {
            field.options = data.map((item: ListaValorResponseDto) => ({
              Id: item.Id!,
              Nombre: item.Valor!,
            }));
          }
          return field;
        });
      });
  }

  onSubmit(form: FormGroup): void {
    if (form.invalid) {
      form.markAllAsTouched();
      return;
    }

    const value = form.value;

    const json = {
      ...value,
      numeroEmpleados: +value.numeroEmpleados,
      antiguedad: +value.antiguedad,
      idPersona: this.userInfoSession.idPersona
    };

    this.empresaService.saveDatosAdicionales(json).subscribe({
      next: (response) => {
        this.alertService.exito(this.modalText['titulo-registro-exitoso']);
      },
      error: (error) => {
        this.alertService.error(this.modalText['titulo-registro-fallido']);
      },
    });
  }


  abrirModal() {
    this.modalDatosObservatorio.nativeElement.click();
  }
  // Se consume el servicio que retorna los datos adicionales registrados por el admin
  datosAdicionalesRegistrados() {
    this.empresaService.cargarDatosAdicionales(Number(this.userInfoSession.idPersona)).subscribe((resp: DatosAdicionalesDTO) => {
      this.allFields = this.allFields.map(field => {
        if (resp) {
          if (field.name === 'idTamanoEmpresa') {
            if (resp.tamanoEmpresa) {
              field.value = resp.tamanoEmpresa.id;
            }
          }
          if (field.name === 'numeroEmpleados') {
            if (resp.numeroEmpleados) {
              field.value = resp.numeroEmpleados;
            }
          }
          if (field.name === 'ciiuPrincipal') {
            if (resp.ciiuPrincipal) {
              field.value = resp.ciiuPrincipal;
            }
          }
          if (field.name === 'antiguedad') {
            if (resp.antiguedad) {
              field.value = resp.antiguedad;
            }
          }
          if (field.name === 'idFormaJuridica') {
            if (resp.formaJuridica) {
              field.value = resp.formaJuridica.id;
            }
          }
          return field;
        }
        return field;
      });
    });
  }
}
